"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SummaryTotalSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationCosts = require("../../../../hooks/recommendation/useRecommendationCosts");
var _services = require("../../../../services");
var _recommendationSelectors = require("../../../../store/recommendation/recommendationSelectors");
var _useAppSelector = require("../../../../hooks/useAppSelector");
var _useConfig = _interopRequireDefault(require("../../../../hooks/useConfig"));
var _useCustomer = require("../../../../hooks/questionnaire/useCustomer");
var _useQuestionsMetadata = require("../../../../hooks/questionnaire/useQuestionsMetadata");
var _useRecommendationStatus = require("../../../../hooks/recommendation/useRecommendationStatus");
var _BaseComponents = require("../../../../components/StyledComponents/BaseComponents");
var _constants = require("../../../../utils/constants");
var _RecommendationSummary = _interopRequireDefault(require("../../RecommendationSummary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable @typescript-eslint/no-explicit-any */

const InlineTextContainer = _styledComponents.default.div`
  & p,
  & h2 {
    display: inline-block;
  }
  & p {
    font-size: 12px;
  }
  & h2 {
    font-size: 16px;
  }
`;
const ProductDetailsText = _styledComponents.default.div`
  & p,
  & h2 {
    color: #66686c;
  }
`;
const PricePerProduct = _styledComponents.default.div`
  & p {
    font-size: 20px;
    line-height: 28px;
    color: #002eff;
    font-weight: 600;
  }
`;
const SummaryRowContainer = _styledComponents.default.div`
  display: 'flex';
  gap: '0';
  flex-direction: 'column';
`;
const SummaryTotalSection = _ref => {
  var _Services$locale$loca, _transformedPlan$addi;
  let {
    flexDirection,
    flexBasis,
    breakPoints,
    discountedPrice,
    pricePerPlanAfterDiscount,
    transformedPlan
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "total-summary"
  }, /*#__PURE__*/_react.default.createElement(SummaryRowContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    dataAttributes: {
      'data-testid': `total-title`
    },
    text: _services.Services.locale.localeString('Recommendation.totalPlan'),
    noMargin: true
  }), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': `total-after-discount`
    },
    size: 1,
    weight: 3,
    text: _services.Services.locale.formatPrice(discountedPrice),
    noMargin: true
  }))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between",
    gap: "10px"
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
    flexBasis: flexBasis,
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: breakPoints.sm ? 3 : 0
    }
  }, transformedPlan && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-testid': `total-subtitle`
    }
  }, (_Services$locale$loca = _services.Services.locale.localeString('Recommendation.pricePerMonth', {
    amount: transformedPlan === null || transformedPlan === void 0 ? void 0 : (_transformedPlan$addi = transformedPlan.additional) === null || _transformedPlan$addi === void 0 ? void 0 : _transformedPlan$addi.termDuration,
    pluralUnit: _services.Services.locale.localeString('Recommendation.Month')
  })) === null || _Services$locale$loca === void 0 ? void 0 : _Services$locale$loca.toLocaleLowerCase())))), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
    flexBasis: flexBasis,
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: breakPoints.sm ? 3 : 0
    }
  }, transformedPlan && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-testid': `total-before-discount`
    }
  }, _services.Services.locale.formatPrice(transformedPlan === null || transformedPlan === void 0 ? void 0 : transformedPlan.totalTermWithoutDiscount))))))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
    flexBasis: flexBasis,
    flexGrow: 1
  }, /*#__PURE__*/_react.default.createElement(PricePerProduct, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: breakPoints.sm ? 3 : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    dataAttributes: {
      'data-testid': `total-per-plan`
    }
  }, _services.Services.locale.formatPrice(pricePerPlanAfterDiscount), _services.Services.locale.localeString('Recommendation.perPlan')))))))));
};
exports.SummaryTotalSection = SummaryTotalSection;
const EntelSummarySection = _ref2 => {
  let {
    testId = null
  } = _ref2;
  const {
    handset,
    plan,
    additionalPlans,
    broadband,
    businessSolution,
    connectivityPlan,
    totalUpfrontCost,
    totalTermCost,
    totalTermCostAfterDiscount,
    discountPrices,
    handsetUpfrontCost
  } = (0, _useRecommendationCosts.useRecommendationCosts)();
  const handsetTermCost = handset === null || handset === void 0 ? void 0 : handset.termCost;

  //---------------- Hooks -----------------

  const numberOfPlans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectAdditionalPlans);
  const breakPoints = (0, _r10SourceLibrary.useBreakpoints)();
  const {
    isCustomer
  } = (0, _useCustomer.useCustomer)();
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)();
  const basicPlanIds = (0, _useConfig.default)('basicPlanIds', []);
  const hidePriceAfterDiscount = (0, _useConfig.default)('hidePriceAfterDiscount', false);
  const minimumDiscount = (0, _useConfig.default)('minimumDiscount', 10);
  const isSmallScreen = breakPoints.sm;
  const showFullPlanName = (0, _useConfig.default)('showFullPlanName', true);
  const planIdWithDifferentHeader = (0, _useConfig.default)('planIdWithDifferentHeader', []);
  const {
    isJourneyForHandsetAndPlan
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  const showTotalSummaryForMixedJourney = (0, _useConfig.default)('uiSettings.showTotalSummaryForMixedJourney', false);
  //------- Calculations and Parsers -------

  const products = [handset, {
    ...plan,
    additional: additionalPlans
  }, broadband, businessSolution, connectivityPlan].filter(product => !!product);

  // Instantiate the parser

  const Parser = (0, _react.useMemo)(() => new _services.Services.Parsers.RecommendationSummaryParser({
    totalTermCost,
    totalTermCostAfterDiscount,
    totalUpfrontCost,
    discountPrices,
    numberOfPlans,
    hidePriceAfterDiscount,
    metadata,
    isCustomer,
    basicPlanIds,
    handsetUpfrontCost,
    products,
    minimumDiscount,
    isSmallScreen,
    handsetTermCost,
    plan,
    showFullPlanName,
    planIdWithDifferentHeader
  }), [totalTermCost, totalTermCostAfterDiscount, totalUpfrontCost, discountPrices, numberOfPlans, hidePriceAfterDiscount, metadata, isCustomer, basicPlanIds, handsetUpfrontCost, products, minimumDiscount, isSmallScreen, handsetTermCost, plan, showFullPlanName, planIdWithDifferentHeader]);

  // Get the values from the parser
  const {
    columns,
    totalNumberOfPlans
  } = Parser.RecommendationSummaryValues;
  const pricePerPlanAfterDiscount = totalTermCostAfterDiscount / totalNumberOfPlans;
  const WrapperComponent = Parser === null || Parser === void 0 ? void 0 : Parser.WrapperComponent;
  //Styling props
  const flexDirection = (0, _react.useMemo)(() => breakPoints.sm ? 'column' : 'row', [breakPoints]);
  const flexBasis = (0, _react.useMemo)(() => Parser.getComponentFlexBasis, [columns]);
  let hideDiscount, priceValue, transformedProducts, transformedPlan;
  if (Parser.RecommendationSummaryValues) {
    hideDiscount = Parser.RecommendationSummaryValues.hideDiscount;
    priceValue = Parser.RecommendationSummaryValues.priceValue;
    transformedProducts = Parser.RecommendationSummaryValues.transformedProducts;
    transformedPlan = transformedProducts.find(product => product.productType === _constants.PRODUCT_TYPES.PLAN);
  }
  const additionalPlanText = _services.Services.locale.localeString(`Recommendation.Additional.additionalText`);
  const additionalPlanHeading = _services.Services.locale.localeString(`Recommendation.plans`);
  return isJourneyForHandsetAndPlan ? /*#__PURE__*/_react.default.createElement(_BaseComponents.BorderWrapper, {
    padding: '20px 24px 20px 24px',
    "data-test-id": `summary-${testId}`
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.PageWrapper, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
    flexDirection: flexDirection,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 2,
    dataAttributes: {
      'data-testid': `order-summary-title-${testId}`
    },
    text: _services.Services.locale.localeString('Recommendation.Summary')
  })), transformedProducts.map(product => {
    var _product$color, _product$color$value$, _product$color$value$2, _product$color$value$3, _Services$locale$loca2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: product.variantId
    }, /*#__PURE__*/_react.default.createElement(SummaryRowContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      dataAttributes: {
        'data-test-id': `plan-section-title-${testId}`
      },
      text: _services.Services.locale.localeString(`Recommendation.${product.productType}`),
      noMargin: true
    }), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      text: `${product.productType === _constants.PRODUCT_TYPES.HANDSET ? _services.Services.locale.formatPrice(priceValue) : product.termCostDisplay}`,
      noMargin: true
    }), product.productType !== _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      weight: 3,
      size: 1
    }, "/", _services.Services.locale.localeString('Recommendation.month')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between",
      gap: "10px"
    }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis,
      flexGrow: 1
    }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: breakPoints.sm ? 3 : 0
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': `plan-name-${testId}`
      }
    }, product.productType === _constants.PRODUCT_TYPES.HANDSET ? `${product === null || product === void 0 ? void 0 : product.productName},
                            ${Parser.getDefaultMemoryValue(product)}, 
                            ${product === null || product === void 0 ? void 0 : (_product$color = product.color) === null || _product$color === void 0 ? void 0 : (_product$color$value$ = _product$color.value.find(c => c.isDefault)) === null || _product$color$value$ === void 0 ? void 0 : (_product$color$value$2 = _product$color$value$.value) === null || _product$color$value$2 === void 0 ? void 0 : (_product$color$value$3 = _product$color$value$2.split('|')) === null || _product$color$value$3 === void 0 ? void 0 : _product$color$value$3[1]}
                            ` : Parser.getPlanName(product))))), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis,
      align: 'right',
      flexGrow: 1
    }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      dataAttributes: {
        'data-testid': `plan-price-order-summary-${testId}`
      },
      size: 1
    }, product.costSubText)))))), product.productType === _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
      appearance: "secondary"
    }), product.additional && !(isCustomer && numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(SummaryRowContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between",
      gap: "10px"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      dataAttributes: {
        'data-testid': `additional-plan-${testId}`
      },
      text: additionalPlanHeading,
      noMargin: true
    }), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      text: `${_services.Services.locale.formatPrice(product.additional.totalCostAfterDiscount)}`,
      noMargin: true
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      weight: 3,
      size: 1
    }, "/", _services.Services.locale.localeString('Recommendation.month')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
      flexDirection: flexDirection,
      justifyContent: "space-between",
      gap: "10px"
    }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis,
      flexGrow: 1
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 1,
      weight: 3,
      dataAttributes: {
        'data-testid': `additional-plan-${testId}`
      },
      text: `${additionalPlanText} (${totalNumberOfPlans - 1})`,
      noMargin: true
    })), !!totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
      flexBasis: flexBasis,
      align: 'right',
      flexGrow: 1
    }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, !hideDiscount && product.additional.totalCostAfterDiscount !== product.additional.totalCost && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
      size: 1
    }, (_Services$locale$loca2 = _services.Services.locale.localeString('Recommendation.pricePerMonth', {
      amount: product.additional.termDuration,
      price: _services.Services.locale.formatPrice(product.additional.totalCost),
      pluralUnit: _services.Services.locale.localeString('Recommendation.Month')
    })) === null || _Services$locale$loca2 === void 0 ? void 0 : _Services$locale$loca2.toLocaleLowerCase())))))));
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    appearance: "secondary"
  }), showTotalSummaryForMixedJourney && /*#__PURE__*/_react.default.createElement(SummaryTotalSection, {
    flexBasis: flexBasis,
    flexDirection: flexDirection,
    breakPoints: breakPoints,
    discountedPrice: totalTermCostAfterDiscount,
    pricePerPlanAfterDiscount: pricePerPlanAfterDiscount,
    transformedPlan: transformedPlan
  }))) : /*#__PURE__*/_react.default.createElement(_RecommendationSummary.default, {
    flexDirection: flexDirection,
    isCustomer: isCustomer
  });
};
var _default = EntelSummarySection;
exports.default = _default;